import React, { useState, useEffect } from "react";
import apiClient from "../../services/apiClient";
import { getHeaders } from "../ApiHeaders/apiHeaders";

const FilterSetup = ({ onAssetTypesFetched, onIsosFetched }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hasFetchedAssetTypes = sessionStorage.getItem("assetTypesFetched");
    if (hasFetchedAssetTypes) {
      const assetTypesData = JSON.parse(
        sessionStorage.getItem("assetTypesData") as string
      );
      onAssetTypesFetched(assetTypesData);
    } else {
      const fetchAssetTypes = async () => {
        const headers = await getHeaders();
        setLoading(true);
        try {
          const response = await apiClient.get("/ref-data/generation-subtype", {
            headers,
          });
          const assetTypesData = response.data.response.data;
          if (assetTypesData && Array.isArray(assetTypesData)) {
            const fetchedAssetTypes = Array.from(
              new Set(
                assetTypesData.map((item: any) => item.generation_type_code)
              )
            );
            onAssetTypesFetched(fetchedAssetTypes);
            sessionStorage.setItem("assetTypesFetched", "true"); // Set the flag in sessionStorage
            sessionStorage.setItem(
              "assetTypesData",
              JSON.stringify(fetchedAssetTypes)
            ); // Store data
          } else {
            setError("No asset types found or invalid response structure");
          }
        } catch (err) {
          setError("Failed to load asset types");
          console.error("Error fetching asset types:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchAssetTypes();
    }
  }, [onAssetTypesFetched]);

  useEffect(() => {
    const hasFetchedIsos = sessionStorage.getItem("isosFetched");
    if (hasFetchedIsos) {
      const isosData = JSON.parse(sessionStorage.getItem("isosData") as string);
      onIsosFetched(isosData);
    } else {
      const fetchIsos = async () => {
        const headers = await getHeaders();
        setLoading(true);
        try {
          const response = await apiClient.get("/iso/?fetch_mode=Default", {
            headers,
          });
          const isosData = response.data.response.data;
          if (isosData && Array.isArray(isosData)) {
            const fetchedIsos = Array.from(
              new Set(isosData.map((item: any) => item.iso_code))
            );
            onIsosFetched(fetchedIsos);
            sessionStorage.setItem("isosFetched", "true"); // Set the flag in sessionStorage
            sessionStorage.setItem("isosData", JSON.stringify(fetchedIsos)); // Store data
          } else {
            setError("No ISOs found or invalid response structure");
          }
        } catch (err) {
          setError("Failed to load ISOs");
          console.error("Error fetching ISOs:", err);
        } finally {
          setLoading(false);
        }
      };

      fetchIsos();
    }
  }, [onIsosFetched]);

  return (
    <>
      {loading && (
        <div className="text-center text-gray-600">Loading data...</div>
      )}
      {error && <div className="text-center text-red-600">{error}</div>}
    </>
  );
};

export default FilterSetup;
